import { checkUserAccessLevel, ADMIN_TYPE_LEVELS } from "./permission";

export function showSettings(
  userPermissions,
  business,
  product,
  service,
  isCurrentUser = false
) {
  if (isCurrentUser) {
    return true;
  }
  if (!userPermissions?.length) {
    return false;
  }

  const accessLevel = checkUserAccessLevel(
    userPermissions,
    business,
    product,
    service
  );

  // Only super admin has settings access
  return accessLevel === ADMIN_TYPE_LEVELS.super;
}
